// @ts-ignore - data.json is generated at build time
import changelogData from '../changelog/data.json';

/**
 * Interface representing a single changelog entry.
 */
export interface ChangelogEntry {
  version: string;
  date: string;
  audiences: ('customer' | 'internal')[];
  types: ('feature' | 'improvement' | 'fix' | 'breaking' | 'security')[];
  title: string;
  description: string;
  image?: string;
  /** Content map of audience -> markdown string */
  content?: Record<string, string>;
  /** The resolved content for the requested audience (helper for UI) */
  resolvedContent?: string;
}

/**
 * Retrieves changelog entries filtered by audience.
 * 
 * @param audience - The target audience ('customer' or 'internal').
 * @returns Array of ChangelogEntry with resolved content.
 */
export const getChangelogs = (audience: 'customer' | 'internal' = 'customer'): ChangelogEntry[] => {
  return (changelogData as any[]).map(entry => {
      // 1. Try to get specific audience content
      let content = entry.content?.[audience];
      
      return {
          ...entry,
          resolvedContent: content
      } as ChangelogEntry;
  }).filter(entry => {
      // Filter out entries that have no content for this audience AND are not explicitly marked for this audience (metadata check)
      const isAudienceAllowed = entry.audiences.includes(audience);
      const hasContent = !!entry.resolvedContent;

      return isAudienceAllowed && hasContent;
  });
};
